exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-body--loading[data-v-253a9b25] {\n  min-height: 60vh;\n}", ""]);

// exports
